import {Component, Vue} from 'vue-property-decorator';

@Component
export default class ThemeMixin extends Vue {
    created() {
        let color = '';
        if (window.location.pathname.includes('residential')) {
            color = getComputedStyle(document.documentElement).getPropertyValue('--color-red');
        } else {
            color = getComputedStyle(document.documentElement).getPropertyValue('--color-blue');
        }

        document.documentElement.style.setProperty('--theme-button-color', color);
        document.documentElement.style.setProperty('--theme-color', color);
    }

    get backgroundColor() {
        if (window.location.pathname.includes('residential')) {
            return "var(--color-red)";
        } else {
            return "var(--color-blue)";
        }
    }
}